import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { RulerIcon } from '@yonderland/andes-icons';
import { BottomSheet, Box, getScreenMinWidth, Icon, LinkButton, Sidebar, Stack, TextAlpha, useIsClient, useLockBodyScroll, useMediaQuery, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetSizeGuideData } from '../../../redux/product/selectors/ProductSelector';
import { generateTestId } from '../../../util/TestUtil';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
const TEST_ID = 'size_guide';
const SIZE_GUIDE_OPEN_ANIMATION_DELAY = 300;
export const SizeGuide = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { pdpTemplateName } = useAemConfig();
    const { sizeGuideContent, sizeGuideContentUrl } = useSelector(makeGetSizeGuideData());
    const dispatch = useDispatch();
    const isPopup = Boolean(sizeGuideContent);
    const isMobile = useMediaQueryMatchesOnMobile();
    const isClient = useIsClient();
    const isDesktopLarge = useMediaQuery(getScreenMinWidth('lg'));
    const sidebarWidth = isDesktopLarge ? '480px' : '420px';
    const [isOpen, setIsOpen] = useState(false);
    useLockBodyScroll(isOpen);
    const handleClose = () => setIsOpen(false);
    const handleSizeGuideOpen = () => {
        dispatch(productActions.sizeGuideOpen());
        dispatch(analyticsActions.productDetailSizeGuideClick(pdpTemplateName));
        if (isPopup) {
            setIsOpen(true);
        }
        else {
            window.open(sizeGuideContentUrl, '_blank');
        }
    };
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => EventUtil.dispatch(EventEnum.SIZE_GUIDE_POPOVER_OPEN), SIZE_GUIDE_OPEN_ANIMATION_DELAY);
        }
    }, [isOpen]);
    if (!sizeGuideContent && !sizeGuideContentUrl) {
        return null;
    }
    const title = t('product.size.guide.link');
    const content = (_jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(TextAlpha, { as: "h2", color: "emphasised", variant: "headingS", children: title }), _jsx(Box, { overflow: "y-auto", children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) })] }));
    return (_jsxs(Box, { testId: TEST_ID, children: [_jsxs(LinkButton, { onClick: handleSizeGuideOpen, testId: generateTestId({ testId: TEST_ID, suffix: 'link' }), variant: "secondary", children: [_jsx(Icon, { source: RulerIcon, size: "xs" }), title] }), isPopup &&
                isClient &&
                createPortal(isMobile ? (_jsx(BottomSheet, { ariaLabel: title, fullHeightOnScroll: true, hasCloseBtn: true, isOpen: isOpen, onClose: handleClose, testId: generateTestId({ testId: TEST_ID, suffix: 'popup' }), zIndex: "drawer", children: content })) : (_jsx(Sidebar, { ariaLabel: title, customWidth: sidebarWidth, hasBackdrop: true, hasCloseBtn: true, hasCloseBtnSpacing: false, isOpen: isOpen, onClose: handleClose, position: "fixed", side: "right", testId: generateTestId({ testId: TEST_ID, suffix: 'popup' }), zIndex: "drawer", children: content })), document.body)] }));
};
